import React, { useEffect, useMemo, useState } from "react";
import { Box, FormControl, useMediaQuery } from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import "./style.css";

const DateInputField = ({
  label = "",
  name = "date",
  width = "auto",
  defaultValue = "",
  isInvalid = false,
  isDisabled = false,
  errorMessage = "Enter details",
  fromDate = "",
  toDate = "",
  onChange = () => {},
  important = false,
  dashboard = false,
  forceRemount = false,
}) => {
  const today = new Date();
  const todayString = today.toLocaleDateString("en-CA");
  
  // Calculate 3 months ago for from_date minimum
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  const threeMonthsAgoString = threeMonthsAgo.toLocaleDateString("en-CA");

  const [value, setValue] = useState(defaultValue);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const formControlKey = useMemo(() => Date.now(), [forceRemount]);

  useEffect(() => {
    setValue(defaultValue);
  }, [forceRemount, defaultValue, []]);

  const handleDateChange = (e) => {
    setValue(e.target.value);
    onChange(e, name);
  };

  const preventTyping = (e) => {
    e.preventDefault();
  };

  return (
    <Box>
      <FormControl isInvalid={isInvalid} isDisabled={isDisabled} w={width}>
        {label && (
          <FormControl.Label>
            {label} {important && <span>*</span>}
          </FormControl.Label>
        )}
        <div className="custom-date-input-container">
          <input
            key={formControlKey}
            name={name}
            value={value}
            type="date"
            className={`custom-date-input ${value ? "has-value" : ""} ${
              isInvalid ? "invalid-input" : ""
            } ${MobileWindow && !value && "mobile-input-date-field"}`}
            onChange={handleDateChange}
            min={
              dashboard
                ? name === "from_date"
                  ? "2020-01-01"
                  : fromDate
                : name === "from_date"
                ? threeMonthsAgoString
                : name === "to_date"
                ? (fromDate ? fromDate : todayString)
                : undefined
            }
            max={
              dashboard
                ? name === "from_date"
                  ? toDate
                  : undefined
                : name === "from_date" && toDate
                ? toDate
                : undefined
            }
            disabled={isDisabled}
            onKeyDown={preventTyping}
          />
          {MobileWindow && (
            <div className="date-input-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
          )}
        </div>
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default DateInputField;
